import { Role } from '../rbac/roles.js'

/**
 * The roles a JIT `defaultRole` may name (TO-335 REQ-003). Capped at
 * `ORG_MANAGER` by TO-410 decision 1: `ORG_ADMIN` is granted only by a
 * Super-Admin, to a specific user — never by an IdP, SCIM or an import.
 */
export const JIT_ASSIGNABLE_ROLES: readonly Role[] = [Role.ORG_USER, Role.ORG_MANAGER]

/** Upper bound on `emailDomainAllowlist` after de-duplication (TO-335 REQ-003). */
export const JIT_MAX_ALLOWLIST_DOMAINS = 50
